// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Departments_departments__5MYFM {
  width: 18%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 10px 15px;
  border-radius: 10px;
  margin-top: 15px;
  color: black;
}
.Departments_departments__5MYFM .Departments_department-card__Nqmi7 {
  margin: 5px 0;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  padding: 10px;
  cursor: pointer;
}
.Departments_departments__5MYFM .Departments_department-card-selected__CUGKC {
  box-shadow: 0 0 10px 0 rgba(255, 0, 110, 0.45);
}
.Departments_departments__5MYFM .Departments_department-title__p7bfm {
  font-size: 18px;
  font-weight: bold;
  color: var(--explore-color);
  margin-bottom: 10px !important;
  display: flex;
  align-items: center;
}
.Departments_departments__5MYFM .Departments_department-title__p7bfm svg {
  margin-right: 5px;
  width: 24px;
  height: 24px;
}
.Departments_departments__5MYFM .Departments_department-title__p7bfm svg path {
  stroke: var(--explore-color);
  stroke-width: 1.5;
}
@media only screen and (max-width: 480px) {
  .Departments_departments__5MYFM {
    display: none;
  }
}

.Departments_shadow__7Gyos {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/Departments/Departments.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AACF;AAAE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,eAAA;AAEJ;AAAE;EACE,8CAAA;AAEJ;AAAE;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAEJ;AADI;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAGN;AAFM;EACE,4BAAA;EACA,iBAAA;AAIR;AAAE;EArCF;IAsCI,aAAA;EAGF;AACF;;AADA;EACE,yCAAA;AAIF","sourcesContent":[".departments {\n  width: 18%;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  padding: 10px 15px;\n  border-radius: 10px;\n  margin-top: 15px;\n  color: black;\n  .department-card {\n    margin: 5px 0;\n    width: 100%;\n    border-radius: 10px;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n    padding: 10px;\n    cursor: pointer;\n  }\n  .department-card-selected {\n    box-shadow: 0 0 10px 0 rgba(255, 0, 110, 0.45);\n  }\n  .department-title {\n    font-size: 18px;\n    font-weight: bold;\n    color: var(--explore-color);\n    margin-bottom: 10px !important;\n    display: flex;\n    align-items: center;\n    svg {\n      margin-right: 5px;\n      width: 24px;\n      height: 24px;\n      path {\n        stroke: var(--explore-color);\n        stroke-width: 1.5;\n      }\n    }\n  }\n  @media only screen and (max-width: 480px) {\n    display: none;\n  }\n}\n.shadow {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"departments": `Departments_departments__5MYFM`,
	"department-card": `Departments_department-card__Nqmi7`,
	"department-card-selected": `Departments_department-card-selected__CUGKC`,
	"department-title": `Departments_department-title__p7bfm`,
	"shadow": `Departments_shadow__7Gyos`
};
export default ___CSS_LOADER_EXPORT___;
